module.exports = "/static/assets/71ef8203c6c58b67fa11b34cca8f5ba1.svg";